import { axiosInstance } from "../../../utils";

const actions = {
    CREATE_OR_UPDATE_BANNER_REQUESTED: 'CREATE_OR_UPDATE_BANNER_REQUESTED',
    CREATE_OR_UPDATE_BANNER_SUCCEEDED: 'CREATE_OR_UPDATE_BANNER_SUCCEEDED',
    CREATE_OR_UPDATE_BANNER_FAILED: 'CREATE_OR_UPDATE_BANNER_FAILED',

    addOrUpdateBanner: (data = undefined) => {
        return {
            type: actions.CREATE_OR_UPDATE_BANNER_REQUESTED,
            payload: data
        }},

    createOrUpdateBanner: async (data = undefined) => {
        let url = `banners/create`;
        let bodyFormData = new FormData();

        if (data.title) bodyFormData.set('title', data.title );
        if (data.title_ar) bodyFormData.set('title_ar', data.title_ar );
        if (data.placeholder) bodyFormData.set('placeholder', data.placeholder);
        if (data.placeholder_ar) bodyFormData.set('placeholder_ar', data.placeholder_ar);
        if (data.item_ids) bodyFormData.set('item_ids', JSON.stringify(data.item_ids));

        bodyFormData.set('is_active', data.is_active ? true : false);

        if (data.image) bodyFormData.append('image', data.image );
        if (data.image_ar) bodyFormData.append('image_ar', data.image_ar);

        if(data._id) {
            url = `banners/` + data._id
            try {
                const banner = await axiosInstance.put(url, bodyFormData);
                return banner.data;
            } catch (error) {
                throw error;
            }
        } else {
            try {
                const banner = await axiosInstance.post(url, bodyFormData);
                return banner.data;
            } catch (error) {
                throw error;
            }
        }
    }
};

export default actions;
